<template>
    <div id="">
        <report-header 
            :title="componentsData.headerTitle" 
            backTo="performance"
            backRoute="/report/performance"
            :backOption="true"></report-header>
        <scenary-options></scenary-options>
        <placing></placing>
        <warning></warning>
        <button-next :title="componentsData.buttonNextTitle" nextRoute="feedback"></button-next>
    </div>
</template>

<script>
import Header from '../../components/shared/report/Header'
import ButtonNext from '../../components/shared/report/ButtonNext'
import ScenaryOptions from '../../components/shared/report/ScenaryOptions'
import Warning from '../../components/shared/report/Warning'
import Placing from '../../components/shared/report/ranking/Placing'
export default {
    name: '',
    props:[],
    components:{
        'report-header': Header,
        'button-next': ButtonNext,
        ScenaryOptions,
        Warning,
        Placing
    },
    data: () => ({
        componentsData: {
            headerTitle: 'Ranking',
            buttonNextTitle: 'Feedback'
        }
    })
}
</script>

<style lang="scss" scoped>
    
</style>
